import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ViewEncapsulation } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';


@Component({
  selector: 'app-readdata',
  templateUrl: './readdata.component.html',
  styleUrls: ['./readdata.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReaddataComponent implements OnInit {
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  searchText: string;
  myFiles: string[] = [];
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;
  sOnboardingId: string;
  AuditType:string;


  displayedColumns: string[] = ['sno', 'boeName', 'uploadedDate', 'noOfLineItems', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  @ViewChild('file')
  myInputVariable: ElementRef;

  constructor(private http: HttpClient, private SpinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('AduitUploadRead');
    this.vWrite = localStorage.getItem('AduitUploadWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }
debugger;
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      // Swal.fire({
      //   title: 'Are you sure?',
      //   text: 'Please Select A Customer First!',

      //   showCancelButton: true,
      //   confirmButtonText: 'Yes, delete it!',
      //   cancelButtonText: 'No, keep it'
      // }).then((result) => {
      //   if (result.value) {

      //   } else if (result.dismiss === Swal.DismissReason.cancel) {

      //   }
      // })
    }
    this.AuditType="Post";
  }

  public uploadFile = (files) => {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      this.myInputVariable.nativeElement.value = "";
      return;
    }
    this.SpinnerService.show();
    this.isShownError = true;
    this.isShownSuccess = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";

    if (files.length == 0) {
      return;
    }
    for (var i = 0; i < files.length; i++) {
      this.myFiles.push(files[i]);
    }
    debugger;
    //let fileToUpload = <File>files[0];
    const formData = new FormData();
    //formData.append('file', fileToUpload, fileToUpload.name);
    for (var i = 0; i < this.myFiles.length; i++) {
      formData.append("file[]", this.myFiles[i]);
    }
    var cusId = sessionStorage.getItem('CustomerId');
    // let fileToUpload = <File>files[0];
    // const formData = new FormData();
    // formData.append('file', fileToUpload, fileToUpload.name);
    var vCorporateName=localStorage.getItem('corporateName');
    var vCorporateAddress2=localStorage.getItem('corporateAddress2');
    var vLoginId = localStorage.getItem("LoginId");
    var vLoginMail = localStorage.getItem("LoginMail");
    

    //this.http.post('http://localhost:57622/api/Category/SavePRNdata', formData).subscribe(
    // this.http.post(environment.apiUrl + 'ReadData/SavePRNdata', formData,{ params: params }).subscribe(
    //   (response) => {
    //     debugger;
    //     alert(response);
    //   },
    //   (error) => {
    //     debugger;
    //     var vDataError = JSON.stringify(error.error.text);
    //     var vErrorMsg = vDataError.replace('"', '');
    //     var vErrorMsg1 = vErrorMsg.replace('"', '');
    //     this.SpinnerService.hide();  
    //     //item.vFile = vErrorMsg1;
    //     if (vErrorMsg1 == "Success") {
    //       ((document.getElementById('myfile') as HTMLInputElement).value) = null;
    //       this.isShownSuccess = false;
    //       this.SuccessMsg = "Bill Of Entry Imported Successfully.";
    //       return false;
    //     }
    //     else if (vErrorMsg1 == "Failed") {
    //       ((document.getElementById('myfile') as HTMLInputElement).value) = null;
    //       this.isShownError = false;
    //       this.ErrorMsg = "Bill Of Entry Imported Failed, Please try again..";
    //       return false;
    //     }
    //     else if (vErrorMsg1 == "AlreadyExist") {

    //     }
    //   }
    // )
    //========================== Post Audit Start ========================================
if(this.AuditType=="Post"){
  let params = new HttpParams();
    params = params.append('iCClientId', vLoginId);
    params = params.append('sEmail', vLoginMail);
    params = params.append('iOnboardingId', this.sOnboardingId);
    params = params.append('sCorporateName', vCorporateName);
    params = params.append('sCorporateAdd2', vCorporateAddress2);
    this.http.post(environment.apiUrl + 'ReadData/ReadPOEdata', formData, { params: params }).subscribe(
      (response) => {
        debugger;
        this.SpinnerService.hide();
        this.isShownSuccess = false;
        this.SuccessMsg = "Uploaded Successfully. You will receive a Email Shortly.";
        //this.BindBOEGrid();
        this.myInputVariable.nativeElement.value = "";
        this.myFiles = [];
        let params1 = new HttpParams();
        params1 = params1.append('iCClientId', vLoginId);
        params1 = params1.append('sEmail', vLoginMail);
        params1 = params1.append('iOnboardingId', this.sOnboardingId);
        params1 = params1.append('sCorporateName', vCorporateName);
        this.http.post(environment.apiUrl + 'ReadData/SavePRNdata', formData, { params: params1 }).subscribe(
          (response) => {
          });
        //alert(response);
      },
      (error) => {
        debugger;
        var vDataError = JSON.stringify(error.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        this.SpinnerService.hide();
        this.myFiles=[];
        //item.vFile = vErrorMsg1;
        if (vErrorMsg1 == "Success") {
          ((document.getElementById('myfile') as HTMLInputElement).value) = null;
          this.isShownSuccess = false;
          this.SuccessMsg = "Uploaded Successfully. You will receive a Email Shortly.";
          //this.BindBOEGrid();

          

          //return false;
        }
        else if (vErrorMsg1 == "Failed") {
          this.SpinnerService.hide();
          ((document.getElementById('myfile') as HTMLInputElement).value) = null;
          this.isShownError = false;
          this.ErrorMsg = "Bill Of Entry Import Failed, Please Check Your Email For Further Details";
          //return false;
        }
        else if (vErrorMsg1 == "AlreadyExist") {

        }
        let params2 = new HttpParams();
        params2 = params2.append('iCClientId', vLoginId);
        params2 = params2.append('sEmail', vLoginMail);
        params2 = params2.append('iOnboardingId', this.sOnboardingId);
        params2 = params2.append('sCorporateName', vCorporateName);
        params2 = params2.append('sCorporateAdd2', vCorporateAddress2);
        this.http.post(environment.apiUrl + 'ReadData/SavePRNdata', formData, { params: params2 }).subscribe(
          (response) => {
           
          });
        
      }
    )
    }
    //========================== Post Audit End ========================================
    else
    {
      let paramsPre = new HttpParams();
      paramsPre = paramsPre.append('iCClientId', vLoginId);
      paramsPre = paramsPre.append('sEmail', vLoginMail);
      paramsPre = paramsPre.append('iOnboardingId', this.sOnboardingId);
      paramsPre = paramsPre.append('sCorporateName', vCorporateName);
      paramsPre = paramsPre.append('sCorporateAdd2', vCorporateAddress2);
      this.http.post(environment.apiUrl + 'PreAudit/ReadPoePrePdfdata', formData, { params: paramsPre }).subscribe(
        (response) => {
          debugger;
          this.SpinnerService.hide();
          ((document.getElementById('myfile') as HTMLInputElement).value) = null;
          this.isShownSuccess = false;
        this.SuccessMsg = "Uploaded Successfully. You will receive a Email Shortly.";
        },        
      (error) => {
        debugger;
        this.SpinnerService.hide();
        ((document.getElementById('myfile') as HTMLInputElement).value) = null;
        this.isShownError = false;
        this.ErrorMsg = "Bill Of Entry Import Failed, Please Check Your Email For Further Details";
      })
    }
  }
  ProcessedClick() {
    debugger;
    this.BindBOEGrid("Processed");
  }
  DiscrepenciesClick() {
    debugger;
    this.BindBOEGrid("Discrepencies");
  }
  BindBOEGrid(value1) {
    debugger;
    let params = new HttpParams();
    params = params.append('sStatus', value1);
    params = params.append('iOnboardingId', this.sOnboardingId);
    var value = this.http.get(environment.apiUrl + 'ReadData/GetPOEInvoice', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        //if (data.length != 0) {
        //this.items = data;          
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;

        this.dataSource.sort = this.sort;
        // }
        // else {
        // };
      }).catch((data: any) => {
        debugger;

      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

}
